import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { IAssetState, IAssetSchema, IAssets, IVendor, IAddAssetRepairSchema } from './types';
import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';

const initialState: IAssetState = {
  addAsset: {},
  assets: {},
  deleteAsset: {},
  updateAsset: {},
  addVendor: {},
  vendors: {},
  addRepairAssets: {},
  assetDetails: {},
};

const slice = createSlice({
  name: 'assets',
  initialState,
  reducers: {
    addAsset(state, action: PayloadAction<IAssetSchema>) {
      state.addAsset.status = RequestStatus.RUNNING;
    },
    addAssetSuccess(state, action) {
      state.addAsset.status = RequestStatus.SUCCESS;
      state.addAsset.data = action.payload;
    },
    addAssetFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addAsset.status = RequestStatus.ERROR;
      state.addAsset.error = action.payload;
    },
    //
    addRepairAssets(state, action: PayloadAction<IAddAssetRepairSchema>) {
      state.addRepairAssets.status = RequestStatus.RUNNING;
    },
    addRepairAssetsSuccess(state, action) {
      state.addRepairAssets.status = RequestStatus.SUCCESS;
      state.addRepairAssets.data = action.payload;
    },
    addRepairAssetsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addRepairAssets.status = RequestStatus.ERROR;
      state.addRepairAssets.error = action.payload;
    },
    //
    getAssets(state) {
      state.assets.status = RequestStatus.RUNNING;
    },
    getAssetsSuccess(state, action: PayloadAction<IAssetState['assets']['data']>) {
      state.assets.status = RequestStatus.SUCCESS;
      state.assets.data = action.payload;
    },
    getAssetsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.assets.status = RequestStatus.ERROR;
      state.assets.error = action.payload;
    },
    //
    deleteAsset(state, action: PayloadAction<{ id: number }>) {
      state.deleteAsset.status = RequestStatus.RUNNING;
    },
    deleteAssetSuccess(state) {
      state.deleteAsset.status = RequestStatus.SUCCESS;
    },
    deleteAssetFailed(state, action: PayloadAction<IRequestFailed>) {
      state.deleteAsset.status = RequestStatus.ERROR;
      state.deleteAsset.error = action.payload;
    },
    updateAsset(state, action: PayloadAction<any>) {
      state.updateAsset.status = RequestStatus.RUNNING;
    },
    updateAssetSuccess(state, action: PayloadAction<IAssets>) {
      state.updateAsset.status = RequestStatus.SUCCESS;
      state.updateAsset.data = action.payload;
    },
    updateAssetFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateAsset.status = RequestStatus.ERROR;
      state.updateAsset.error = action.payload;
    },
    addVendor(state, action: PayloadAction<IVendor>) {
      state.addVendor.status = RequestStatus.RUNNING;
    },
    addVendorSuccess(state, action) {
      state.addVendor.status = RequestStatus.SUCCESS;
      state.addVendor.data = action.payload;
    },
    addVendorFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addVendor.status = RequestStatus.ERROR;
      state.addVendor.error = action.payload;
    },
    //
    getVendors(state) {
      state.vendors.status = RequestStatus.RUNNING;
    },
    getVendorsSuccess(state, action: PayloadAction<IAssetState['vendors']['data']>) {
      state.vendors.status = RequestStatus.SUCCESS;
      state.vendors.data = action.payload;
    },
    getVendorsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.vendors.status = RequestStatus.ERROR;
      state.vendors.error = action.payload;
    },
    //
    getAssetDetails(state, action: PayloadAction<IAssetSchema>) {
      state.assetDetails.status = RequestStatus.RUNNING;
    },
    getAssetDetailsSuccess(state, action: PayloadAction<IAssetState['assetDetails']['data']>) {
      state.assetDetails.status = RequestStatus.SUCCESS;
      state.assetDetails.data = action.payload;
    },
    getAssetDetailsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.assetDetails.status = RequestStatus.ERROR;
      state.assetDetails.error = action.payload;
    },
  },
});

export default slice.reducer;
export const {
  addAsset,
  addAssetSuccess,
  addAssetFailed,
  getAssets,
  getAssetsSuccess,
  getAssetsFailed,
  deleteAsset,
  deleteAssetSuccess,
  deleteAssetFailed,
  updateAsset,
  updateAssetFailed,
  updateAssetSuccess,
  addVendor,
  addVendorFailed,
  addVendorSuccess,
  getVendors,
  getVendorsFailed,
  getVendorsSuccess,
  getAssetDetails,
  getAssetDetailsSuccess,
  getAssetDetailsFailed,
  addRepairAssets,
  addRepairAssetsSuccess,
  addRepairAssetsFailed,
} = slice.actions;
